<template>
  <div id="animated-background">
    <img ref="planeLeft" id="animated-plane-left" :style="{top: planeLeftTop}" :src="require('../../assets/img/plane_left.svg')" />
    <img ref="planeRight" id="animated-plane-right" :style="{top: planeRightTop}" :src="require('../../assets/img/plane_right.svg')" />
    <div id="animated-background-content"><slot></slot></div>
  </div>
</template>

<script>
import anime from 'animejs'
export default {
  name: 'animated-background',
  data () {
    return {
      planeLeftTop: '40vh',
      planeRightTop: '30vh'
    }
  },
  mounted () {
    anime({
      targets: this.$refs['planeRight'],
      translateX: [
        {value: -document.documentElement.clientWidth - 200, duration: 10000}
      ],
      duration: 30000,
      easing: 'linear',
      complete: (anim) => {
        this.planeRightTop = Math.floor(Math.random() * 40 + 10) + 'vh'
        anim.restart()
      },
      loop: false
    })
    anime({
      targets: this.$refs['planeLeft'],
      translateX: [
        {value: document.documentElement.clientWidth + 200, duration: 10000}
      ],
      delay: 4000,
      duration: 10000,
      easing: 'linear',
      complete: (anim) => {
        this.planeLeftTop = Math.floor(Math.random() * 25 + 15) + 'vh'
        anim.restart()
      },
      loop: false
    })
  }
}
</script>

<style lang="scss" scoped>
  #animated-background{
    position: absolute;
    overflow: hidden;
    top: 0;
    left: 0;
    right: 0;
    width: 100vw;
    height: 100vh;
    background: url("../../assets/img/Background.png");
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center bottom;
  }

  #animated-background-content {
    position: relative;
    z-index: 10;
    height: 100%;
    overflow: auto;
  }

  #animated-plane-left, #animated-plane-right {
    position: absolute;
    z-index: 2;
  }

  #animated-plane-left {
    width: 80px;
    // left: 100px;
    left: -100px;
  }

  #animated-plane-right {
    width: 60px;
    // right: 100px;
    right: -100px;
  }

</style>
